import Matter from 'matter-js'
window.WorldAnimator =  function() {
    var debug = false;

    var Engine = Matter.Engine,
        Render = Matter.Render,
        Runner = Matter.Runner,
        Composites = Matter.Composites,
        Common = Matter.Common,
        Constraint = Matter.Constraint,
        MouseConstraint = Matter.MouseConstraint,
        Mouse = Matter.Mouse,
        Composite = Matter.Composite,
        Bodies = Matter.Bodies;

    // create engine
    var engine = Engine.create(),
        world = engine.world;

    world.gravity.y = 2;
    // create renderer
    var render = Render.create({
        element: document.getElementById('blCircles'),
        engine: engine,
        options: {
            width: 260,
            height: 240,
            // showAngleIndicator: true
            wireframes: debug,
            background: !debug ? 'transparent':'#000'
        }
    });

    Render.run(render);

    // create runner
    var runner = Runner.create();
    Runner.run(runner, engine);

    // top circle
    var body = Bodies.circle(95, -55, 48, {
        density: 0.003,
        render: {
            fillStyle: 'transparent',
            lineWidth: 5,
            strokeStyle:'#ff4445'
        }
    });
    body.collisionFilter = {
      'group': -1,
      'category': 2,
      'mask': 0,
    };


    var constraint = Constraint.create({
        pointA: { x: 94.5, y: 2 },
        bodyB: body,
        pointB: { x: 0, y: 0 },
        stiffness: 1,
        damping: 1,
        render: {
            visible: debug
        }

    });

    Composite.add(world, [body, constraint]);

    var pBody = body;

    //bottom circle
    var body = Bodies.circle(50,-100, 65, {
        density: 0.005,
        render: {
            fillStyle: 'transparent',
            lineWidth: 5,
            strokeStyle:'#ff4445'
        }
    });
    body.collisionFilter = {
      'group': -1,
      'category': 2,
      'mask': 0,
    };


    var constraint = Constraint.create({
        pointA: { x: 0, y: 8 },
        bodyA: pBody,
        bodyB: body,
        pointB: { x: 0, y: 0 },
        // stiffness: 0.005,
        // damping: 0.05,
        render: {
            visible: debug
        }

    });
    Composite.add(world, [body, constraint]);


    // fit the render viewport to the scene
    Render.lookAt(render, {
        min: { x: 0, y: 0 },
        max: { x: 260, y: 238 }
    });

    this.shake = function(){
        console.log('shake')
        world.gravity.x = 1;
        setTimeout(function(){
            world.gravity.x = 0;
        }, 200)
    }
};
